import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ClientModel } from '../../../shared/models/client.model';
import { CommonHttpService } from '../../../shared/services/http.service';
import { OauthService } from '../../../shared/services/oauth.service';
import { Response } from '@angular/http';
import { ClientTelephone } from '../../../shared/models/client-telephone';

@Component({
    selector: 'account-profile-contact',
    templateUrl: './account.profile.contact.component.html',
    styleUrls: [],
    encapsulation: ViewEncapsulation.None
})
export class AccountProfileContactComponent {
    @Input('client') client: ClientModel;

    public telephone = '';
    public telephoneIdToUpdate = null;
    public updating = false;

    constructor(
        protected http: CommonHttpService,
        protected oauthService: OauthService
    ) {
        this.oauthService.loadedAuthenticatedUser$.subscribe((client: ClientModel) => {
            this.client = client;
            this.indexTelephones();
        });
    }

    public save() {
        if (null !== this.telephoneIdToUpdate) {
            this.performUpdate();
            return;
        }

        this.performInsert();
    }
    /**
     * Call API to update telephone.
     **/
    private performUpdate() {
        this.http
            .useAuth()
            .put(
                `/account/clients/${this.client.id}/telephones/${this.telephoneIdToUpdate}`,
                {
                    ddd: this.prepareDdd(),
                    number: this.prepareNumber()
                }
            )
            .subscribe(() => {
                this.updating = false;
                this.client.telephone.ddd = this.prepareDdd();
                this.client.telephone.number = this.prepareNumber();
            });
    }
    /**
     * Call API to insert new telephone.
     **/
    private performInsert() {
        this.http
            .useAuth()
            .post(
                `/account/clients/${this.client.id}/telephones`,
                {
                    ddd: this.prepareDdd(),
                    number: this.prepareNumber()
                }
            )
            .subscribe(() => {
                this.updating = false;
                this.client.telephone.ddd = this.prepareDdd();
                this.client.telephone.number = this.prepareNumber();
            });
    }
    /**
     * Remove non-digits and get telephone ddd before number.
     **/
    private prepareDdd() {
        return this.telephone.substr(0, 4).replace(/\D/g, '');
    }
    /**
     * Remove non-digits and get telephone number after ddd.
     **/
    private prepareNumber() {
        return this.telephone.substr(4).replace(/\D/g, '');
    }

    /**
     * Index last client telephone.
     **/
    private indexTelephones() {
        this.http
            .useAuth()
            .get(`/account/clients/${this.client.id}/telephones?_sort=-id&_limit=1`)
            .subscribe((response: Response) => {
                if (response.json().data.length > 0) {
                    const telephone = response.json().data[0];
                    const object = new ClientTelephone();
                    object.id = telephone.id;
                    object.ddd = telephone.ddd;
                    object.number = telephone.number;

                    this.client.telephone = object;
                    this.telephoneIdToUpdate = object.id;
                    this.telephone = `(${object.ddd}) ${object.number}`;
                }
            });
    }
    /**
     * Returns telephone mask regex as array.
     **/
    public loadTelephoneMask() {
        return [
            '(', /\d/, /\d/, ')', ' ',
            /\d/, /\d/, /\d/, /\d/, /\d/, '-',
            /\d/, /\d/, /\d/, /\d/,
        ];
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/account/profile/contact/account.profile.contact.component.ts